import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DateService } from '../service/date.service';

/*
 * Simple pipe to make sure formatted dates are treated as UTC
 *
 * @author ervandongen
 */
@Pipe({
    name: 'customDate',
    standalone: true
})
export class CustomDatePipe implements PipeTransform {
    private dateService = inject(DateService);

    locale: string = inject(LOCALE_ID);
    private datePipe: DatePipe;

    constructor() {
        this.datePipe = new DatePipe(this.locale);
    }

    transform(value: Date, format: string): string {
		let translatedFormat = $localize `${format}`;
		if (format === 'dd-MM') {
			translatedFormat = $localize `:@@date_format.dd-MM:dd-MM`;
		}

        if (value !== undefined) {
            return this.datePipe.transform(
                this.dateService.treatAsUTC(value),
	            translatedFormat
            )!;
        }

        return '';
    }
}
